import "./Skills.css";
import Marquee from "react-fast-marquee";
import { useTheme, Text } from "@chakra-ui/react";
import html from "../../assets/html.svg";
import docker from "../../assets/docker.svg";
import css from "../../assets/css.svg";
import javascript from "../../assets/javascript.svg";
import react from "../../assets/react.svg";
import mongodb from "../../assets/mongodb.svg";
import postgresql from "../../assets/postgresql.svg";
import git from "../../assets/git.svg";
import canva from "../../assets/canva.svg";
import figma from "../../assets/figma.svg";
import nodejs from "../../assets/nodejs.svg";
import auth0 from "../../assets/auth0.svg";
import jest from "../../assets/jest.svg";
import github from "../../assets/github.svg";
import express from "../../assets/express.svg";
import heroku from "../../assets/heroku.svg";
import restapi from "../../assets/restapi.svg";
import mantine from "../../assets/mantine.svg";
import reactnative from "../../assets/reactnative.svg";
import less from "../../assets/less.svg";
import typescript from "../../assets/typescript.svg";
import graphql from "../../assets/graphql.svg";

const skills = [
    { skill: "Javascript", skillImage: javascript },
    { skill: "CSS", skillImage: css },
    { skill: "LESS", skillImage: less },
    { skill: "React", skillImage: react },
    { skill: "React Native", skillImage: reactnative },
    { skill: "Typescript", skillImage: typescript },
    { skill: "GraphQL", skillImage: graphql },
    { skill: "HTML", skillImage: html },
    { skill: "MongoDB", skillImage: mongodb },
    { skill: "PostgreSQL", skillImage: postgresql },
    { skill: "Docker", skillImage: docker },
    { skill: "Git", skillImage: git },
    { skill: "NodeJS", skillImage: nodejs },
    { skill: "Canva", skillImage: canva },
    { skill: "Figma", skillImage: figma },
    { skill: "Auth0", skillImage: auth0 },
    { skill: "Jest", skillImage: jest },
    { skill: "GitHub", skillImage: github },
    { skill: "Heroku", skillImage: heroku },
    { skill: "Express", skillImage: express },
    { skill: "Rest API", skillImage: restapi },
    { skill: "Mantine", skillImage: mantine },
];

const Skills = () => {
    const theme = useTheme();
    return (
        <div
            className="skills"
            id="skills"
            style={{
                color: theme.colors.secondary,
            }}
        >
            <h1 className="sectionHeading">Skills</h1>
            <div className="skillScroll">
                <Marquee
                    gradient={false}
                    speed={160}
                    delay={0}
                    play={true}
                    direction="left"
                >
                    {skills.map((skill) => (
                        <div className="skillBox" key={skill.skill}>
                            <img src={skill.skillImage} alt={skill.skill} />
                            <Text
                                className="skillName"
                                style={{ color: theme.colors.primary }}
                            >
                                {skill.skill}
                            </Text>
                        </div>
                    ))}
                </Marquee>
            </div>
        </div>
    );
};

export default Skills;
